import { render, staticRenderFns } from "./OcrModalContent.vue?vue&type=template&id=521b0642&scoped=true"
import script from "./OcrModalContent.vue?vue&type=script&lang=js"
export * from "./OcrModalContent.vue?vue&type=script&lang=js"
import style0 from "./OcrModalContent.vue?vue&type=style&index=0&id=521b0642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b0642",
  null
  
)

export default component.exports